import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import type { FiltersUiVersion } from '@zaoblako/web/core/types/filters-ui-version.type';
import { ConverterFindInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-find.dto';
import { ConverterService } from '@zaoblako/web/core/services/control/converter.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';

@Component({
  selector: 'crm-converter-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent],
  templateUrl: './converter-multi-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConverterMultiSelectComponent implements OnInit, OnDestroy {
  @Input() public filtersUiVersion: FiltersUiVersion = 'v2';

  @Input() public converters: ConverterFindInterface[] = [];

  @Input() public selectedConverters: ConverterFindInterface[] = [];
  @Output() public selectedConvertersChange = new EventEmitter<ConverterFindInterface[]>();

  @Input() public customRequest = false;
  @Input() public sort: string;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = true;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public isFloatLabel = true;
  @Input() public placeholder = '\u00A0';
  @Input() public display = 'chip';
  @Input() public appendTo: string;

  private loadedConverters = false;
  private timer: ReturnType<typeof setInterval>;

  @Input() public set setSelectedConverterIds(ids: number[]) {
    if (ids?.length) {
      ids.forEach((id, index) => {
        if (typeof id === 'string') {
          ids[index] = +id;
        }
      });
    }

    if (
      ids?.length &&
      ((this.selectedConverters?.length &&
        !this.selectedConverters?.every((selectedConverter) => ids.includes(selectedConverter.id))) ||
        !this.selectedConverters?.length)
    ) {
      if (this.loadedConverters) {
        this.selectedConverters = this.converters.filter((converter) => ids.includes(converter.id));
      } else {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          if (this.loadedConverters) {
            this.selectedConverters = this.converters.filter((converter) => ids.includes(converter.id));
            this.cdRef.markForCheck();
            clearInterval(this.timer);
          }
        }, 500);
      }
    }
  }

  public constructor(
    private readonly converterService: ConverterService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly globalService: GlobalService
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      this.globalService.globalInfo.tenantInfo?.ratePlan?.modulesAccessControl?.PHYSICAL_ACCESS_CONTROL?.enabled
    ) {
      this.converterService.findAll({ list: true }).subscribe({
        next: (converters) => {
          this.converters = converters;
          this.loadedConverters = true;
          this.cdRef.markForCheck();
        },
        error: () => {
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
      });
    } else {
      this.loadedConverters = true;
    }
  }

  public ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
